import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../context/LanguageContext";
import "./clientTheme.css";
import "./LanguageSwitcher.css";

function GlobeIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  );
}

export default function LanguageSwitcher() {
  const { t } = useTranslation("header");
  const { language, setLanguage, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div className="client-language-switcher" ref={ref}>
      <button
        type="button"
        className="client-language-switcher-button"
        onClick={() => setOpen((v) => !v)}
        aria-label={t("header:changeLanguageAriaLabel")}
      >
        <GlobeIcon />
        <span>{languages[language].nativeLabel}</span>
      </button>
      {open && (
        <div className="client-language-switcher-menu">
          {Object.values(languages).map((lang) => (
            <button
              key={lang.code}
              type="button"
              className={
                "client-language-switcher-item" + (lang.code === language ? " active" : "")
              }
              onClick={() => {
                setLanguage(lang.code);
                setOpen(false);
              }}
            >
              {lang.nativeLabel}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
